<app-management-sidemenu [(isOpen)]="isSideNavOpen"
                         [managementType]="selectedManagementType"
                         [actionType]="selectedActionType"
                         (close)="isSideNavOpen = false"
                         [selectedAppVersion]="selectedAppVersion"
                         (refreshTable)="getPaginatedQuery()">
  <h1>{{ "appVersionManagement" | localize }}</h1>
  <div class="company-management-container custom-admin-label-class"
       [ngClass]="{
      'sidenav-open': isSideNavOpen,
      'sidenav-close': !isSideNavOpen
    }">
    <div class="company-management-header">
      <div class="company-management-process">
        <button class="add-new-company"
                style="cursor: pointer"
                (click)="
            openSideNav(ManagementType.AppVersionManagement, ActionType.Create)
          ">
          <span> {{ "newAppVersion" | localize }} </span>
          <img src="assets/icons/general/add-icon.png" alt="" />
        </button>
      </div>
    </div>

    <!-- Table -->
    <div class="table-container">
      <div class="table-responsive">
        <mat-table [dataSource]="dataSource">

          <!-- companyName Column -->
          <ng-container matColumnDef="releaseNote">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label>{{ "releaseNote" | localize }}</mat-label>
                <input [(ngModel)]="inputValues['releaseNote']"
                       matInput
                       (input)="onInputChange($event, 'releaseNote')" />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell *matCellDef="let element"
                      matTooltip="{{ element.releaseNote }}"
                      matTooltipPosition="below">
              {{ element.releaseNote }}
            </mat-cell>
          </ng-container>

          <!-- teamQuota Column -->
          <ng-container matColumnDef="versionName">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label>{{ "versionName" | localize }}</mat-label>
                <input [(ngModel)]="inputValues['versionName']"
                       matInput
                       (input)="onInputChange($event, 'versionName')" />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell *matCellDef="let element"
                      matTooltip="{{ element.versionName }}"
                      matTooltipPosition="below">
              {{ element.versionName }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="applicationTypeId">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label>{{ "applicationType" | localize }}</mat-label>
                <input [(ngModel)]="inputValues['applicationTypeId']"
                       matInput
                       (input)="onInputChange($event, 'applicationTypeId')" />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell *matCellDef="let element"
                      matTooltip="{{ element.applicationTypeId }}"
                      matTooltipPosition="below">
              {{ element.applicationTypeId }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="releaseDate">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label>{{ "releaseDate" | localize }}</mat-label>
                <input [(ngModel)]="inputValues['releaseDate']"
                       matInput
                       (input)="onInputChange($event, 'releaseDate')" />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell *matCellDef="let element"
                      matTooltip="{{ element.releaseDate }}"
                      matTooltipPosition="below">
              {{ element.releaseDate }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="applicationPath">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label>{{ "applicationPath" | localize }}</mat-label>
                <input [(ngModel)]="inputValues['applicationPath']"
                       matInput
                       (input)="onInputChange($event, 'applicationPath')" />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell *matCellDef="let element"
                      matTooltip="{{ element.applicationPath }}"
                      matTooltipPosition="below">
              {{ element.applicationPath }}
            </mat-cell>
          </ng-container>

          <!-- options Column -->
          <ng-container matColumnDef="options">
            <mat-header-cell class="options-column" *matHeaderCellDef>
              #
            </mat-header-cell>
            <mat-cell class="options-cell" *matCellDef="let element">
              <button mat-icon-button
                      [matMenuTriggerFor]="actionMenu"
                      aria-label="Options">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu class="options-menu" #actionMenu="matMenu">
                <div class="menu-header">{{ "transactions" | localize }}</div>
                <button mat-menu-item
                        class="upload-item"
                        matTooltip="{{ 'uploadFile' | localize }}"
                        (click)="file.click()">
                  <!-- you can swap this for an <img> if you have a .png icon -->
                  <mat-icon style="color:green;" class="upload-icon">file_upload</mat-icon>
                  <span>{{ 'uploadFile' | localize }}</span>

                  <!-- hidden file-picker -->
                  <input #file
                         type="file"
                         (change)="uploadFile(file.files, element)"
                         hidden multiple
                   accept="application/vnd.android.package-archive, application/zip, .ipa, .plist, image/png, .txt, .html, .pdf, .log"/>
                </button>
                <button mat-menu-item
                        (click)="
                    openSideNav(
                      ManagementType.AppVersionManagement,
                      ActionType.Update,
                      element
                    )
                  ">
                  <img src="assets/icons/general/edit-project-icon.png"
                       alt="" />
                  {{ "edit" | localize }}
                </button>

                <button mat-menu-item (click)="deleteAppVersion(element)">
                  <img src="assets/icons/general/delete-project-icon.png"
                       alt="" />
                  {{ "appVersionDelete" | localize }}
                </button>
              </mat-menu>
            </mat-cell>
          </ng-container>

          <!-- Define rows -->
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>

      <!--Paginator-->
      <div class="custom-paginator">
        <span *ngIf="appVersionSearchLength > 0; else noRecords">
          {{ appVersionSearchLength }} {{ 'entries' | localize }} {{ currentPage * pageSize + 1 }} -
          {{ Math.min(appVersionSearchLength, (currentPage + 1) * pageSize) }}
          {{ 'betweenDisplayed' | localize }}
        </span>
        <ng-template #noRecords> {{ 'noRecordFound' | localize }} </ng-template>

        <!-- Paginator Buttons -->
        <button (click)="onPageChange(0)" [disabled]="currentPage === 0">
          &laquo;
        </button>
        <button (click)="onPageChange(currentPage - 1)"
                [disabled]="currentPage === 0">
          &lt;
        </button>
        <ng-container *ngFor="let page of visiblePageNumbers">
          <button [class.active]="page - 1 === currentPage"
                  (click)="onPageChange(page - 1)">
            {{ page }}
          </button>
        </ng-container>
        <button (click)="onPageChange(currentPage + 1)"
                [disabled]="currentPage >= totalPages - 1">
          &gt;
        </button>
        <button (click)="onPageChange(totalPages - 1)"
                [disabled]="currentPage >= totalPages - 1">
          &raquo;
        </button>
        <!--PageSize selection-->
        <select [(ngModel)]="pageSize" (change)="updatePageSize($event)">
          <option *ngFor="let option of [5, 10]" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
    </div>
  </div>
</app-management-sidemenu>
